import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.css']
})
export class AccessibilityComponent implements OnInit {
  title = 'WorldERP.com Accessibility';

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:title', content: 'WorldERP.com Accessibility'},
      {property: 'og:type', content: 'WorldERP.com Accessibility'},
      {property: 'og:url', content: '/accessibility'},
      {property: 'og:image', content: ''}
    ]);
  }

}
